import { FiAlertTriangle, FiX } from "react-icons/fi";

interface ForbiddenErrorPopupProps {
  isOpen: boolean;
  onClose: () => void;
  message: string;
}

const ForbiddenErrorPopup: React.FC<ForbiddenErrorPopupProps> = ({
  isOpen,
  onClose,
  message,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center">
      {/* Backdrop with blur effect */}
      <div
        className="absolute inset-0 bg-black/20 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Error popup */}
      <div className="relative bg-white rounded-2xl shadow-2xl p-8 max-w-md mx-4 border border-red-100">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
          aria-label="Close"
        >
          <FiX size={24} />
        </button>

        {/* Error icon */}
        <div className="flex justify-center mb-6">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center">
            <FiAlertTriangle className="text-red-600" size={32} />
          </div>
        </div>

        {/* Error title */}
        <h2 className="text-2xl font-bold text-center text-gray-900 mb-4">
          Access Forbidden
        </h2>

        {/* Error message */}
        <p className="text-center text-gray-600 mb-6 leading-relaxed">
          {message}
        </p>

        {/* Error code */}
        <div className="text-center">
          <span className="inline-block bg-red-50 text-red-700 px-3 py-1 rounded-full text-sm font-medium">
            Error 403
          </span>
        </div>

        {/* Action button */}
        <div className="mt-6 text-center">
          <button
            onClick={onClose}
            className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-lg font-medium transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ForbiddenErrorPopup;
